/* tslint:disable */
/* eslint-disable */
/**
 * 輸送ロット調整API
 * 重量、パレット数、容量制約に基づいてアイテムを輸送ロットに割り当てるAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Item } from './Item';
import {
    ItemFromJSON,
    ItemFromJSONTyped,
    ItemToJSON,
} from './Item';
import type { Transport } from './Transport';
import {
    TransportFromJSON,
    TransportFromJSONTyped,
    TransportToJSON,
} from './Transport';

/**
 * 
 * @export
 * @interface TransportLotRequest
 */
export interface TransportLotRequest {
    /**
     * 入荷日（YYYY-MM-DD形式）
     * @type {Date}
     * @memberof TransportLotRequest
     */
    recDate: Date;
    /**
     * 
     * @type {Array<Transport>}
     * @memberof TransportLotRequest
     */
    transports: Array<Transport>;
    /**
     * 
     * @type {Array<Item>}
     * @memberof TransportLotRequest
     */
    items: Array<Item>;
    /**
     * 積載量下限（％）
     * @type {number}
     * @memberof TransportLotRequest
     */
    minLoadCapacity: number;
}

/**
 * Check if a given object implements the TransportLotRequest interface.
 */
export function instanceOfTransportLotRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recDate" in value;
    isInstance = isInstance && "transports" in value;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "minLoadCapacity" in value;

    return isInstance;
}

export function TransportLotRequestFromJSON(json: any): TransportLotRequest {
    return TransportLotRequestFromJSONTyped(json, false);
}

export function TransportLotRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransportLotRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recDate': (new Date(json['rec_date'])),
        'transports': ((json['transports'] as Array<any>).map(TransportFromJSON)),
        'items': ((json['items'] as Array<any>).map(ItemFromJSON)),
        'minLoadCapacity': json['min_load_capacity'],
    };
}

export function TransportLotRequestToJSON(value?: TransportLotRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rec_date': (value.recDate.toISOString().substring(0,10)),
        'transports': ((value.transports as Array<any>).map(TransportToJSON)),
        'items': ((value.items as Array<any>).map(ItemToJSON)),
        'min_load_capacity': value.minLoadCapacity,
    };
}

